import { format, isSameDay } from 'date-fns';
import EventPill from './EventPill';

/**
 * CalendarWeekView - Mobile week view with vertical day cards
 */
export default function CalendarWeekView({
  weekDays,
  eventsByDay,
  onDayClick,
  getEventDisplayTime,
}) {
  return (
    <div className="space-y-2">
      {/* Week display showing date range */}
      <div className="text-center text-sm" style={{ color: 'var(--color-text-muted)' }}>
        {format(weekDays[0], 'd MMM')} - {format(weekDays[6], 'd MMM yyyy')}
      </div>

      <div className="space-y-2">
        {weekDays.map((day) => {
          const dayKey = format(day, 'yyyy-MM-dd');
          const dayEvents = eventsByDay[dayKey] || [];
          const isToday = isSameDay(day, new Date());

          return (
            <div
              key={dayKey}
              onClick={() => onDayClick(day, dayEvents)}
              className="card cursor-pointer transition-all hover:shadow-md"
              style={{
                boxShadow: isToday ? '0 0 0 2px var(--color-accent-border)' : undefined,
                border: isToday ? '1px solid var(--color-accent-border)' : undefined,
              }}
            >
              <div className="p-3">
                {/* Day header */}
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <div 
                      className="w-10 h-10 rounded-full flex items-center justify-center font-semibold"
                      style={{
                        backgroundColor: isToday ? 'var(--color-accent-bg)' : 'var(--color-bg-surface)',
                        border: isToday ? '1px solid var(--color-accent-border)' : undefined,
                        color: isToday ? 'white' : 'var(--color-text-secondary)',
                      }}
                    >
                      {format(day, 'd')}
                    </div>
                    <div>
                      <div className="font-medium" style={{ color: 'var(--color-text-primary)' }}>
                        {format(day, 'EEEE')}
                      </div>
                      <div className="text-xs" style={{ color: 'var(--color-text-muted)' }}>
                        {format(day, 'MMMM yyyy')}
                      </div>
                    </div>
                  </div>
                  {dayEvents.length > 0 && (
                    <div 
                      className="text-xs px-2 py-1 rounded-full font-medium"
                      style={{ 
                        backgroundColor: 'var(--color-brand-primary-soft)',
                        color: 'var(--color-brand-primary)',
                      }}
                    >
                      {dayEvents.length} event{dayEvents.length !== 1 ? 's' : ''}
                    </div>
                  )}
                </div>

                {/* Events */}
                {dayEvents.length > 0 ? (
                  <div className="space-y-1.5 mt-3">
                    {dayEvents.map((event, eventIndex) => (
                      <EventPill
                        key={`${event.id}-${eventIndex}`}
                        event={event}
                        displayTime={getEventDisplayTime(event)}
                        compact={false}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="text-sm italic mt-2" style={{ color: 'var(--color-text-muted)' }}>
                    No events
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
